<template>
    <div class="card flex-md-row">
        <div class="card-body d-flex flex-column align-items-start py-2 px-3">
            <div class="d-flex flex-row align-items-center justify-content-start w-100">
                <div class="d-flex flex-column justify-content-between mr-3">
                    <span class="badge badge-primary mb-2">
                        {{ order }}
                    </span>
                    <span v-if="service" class="badge" :class="classServiceCode">
                        {{ serviceCode }}
                    </span>
                </div>
                <div class="w-100">
                    <div class="d-flex flex-row align-items-center justify-content-between w-100  mb-1">
                        <strong class="d-inline-block text-info text-break">
                            {{ title }}
                        </strong>
                        <i
                            v-if="!readonlyForm"
                            class="cursor-pointer fa fa-times close"
                            @click.prevent="removeResource">
                        </i>
                    </div>
                    <p class="small mb-0 text-break" v-if="name">
                        {{ name }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OgcMixin from '../mixins/OgcMixin';

export default {
    name: 'ResourceItemSelected',
    mixins: [
        OgcMixin
    ],
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
        pivotKey: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            item: this.value,
        }
    },
    mounted() {
    },
    computed: {
        service() {
            return this.item?.service;
        },
        serviceName() {
            return this.service?.title;
        },
        serviceCode() {
            return this.getServiceCode(this.service)
        },
        classServiceCode() {
            return this.getClassServiceCode(this.service)
        },
        title() {
            return this.item?.title;
        },
        name() {
            return this.item?.name ?? this.item?.layers;
        },
        abstract() {
            return this.item?.abstract;
        },
        pivotData() {
            return this.pivotKey in this.item ? this.item[this.pivot] : {};
        },
        order() {
            return this.pivotData?.order ?? 1;
        },
    },
    methods: {
        removeResource() {
            if(this.readonlyForm){
                return;
            }
            this.$emit('removeResource');
        },
    }
}
</script>

<style lang="scss" scoped>
.close {
    font-size: 1.1rem;
}
</style>